import React from 'react';
import AccountInfo from '../../components/AccountInfo';
import './AccountPage.css';

const AccountPage = () => (
  <div className="account-page">
    <AccountInfo />
  </div>
);

export default AccountPage;
